<template>
  <div v-if="$store.state.responsive.viewDesktopFilters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="id">Id promoción</label>
            <input type="text" class="form-control generalInput" id="id" v-model.trim="promotionId">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="namePromotion">Nombre promoción</label>
            <input type="text" class="form-control generalInput" id="namePromotion" v-model.trim="promotionName">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="status">Estado</label>
            <VueNextSelect
              class="form-control generalInput"
              id="status"
              :options="statusDescriptions"
              v-model.trim="status"
              placeholder=""
              searchable="true"
              clear-on-close="true"
              close-on-select
            >
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-12">
          <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
            <button class="btn btn-primary generalPrimaryButton" :disabled="isLoading" @click="filter">
              <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">
        FILTROS
      </p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="id">Id promoción</label>
              <input type="text" class="form-control generalInput" id="id" v-model.trim="promotionId">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="namePromotion">Nombre promoción</label>
              <input type="text" class="form-control generalInput" id="namePromotion" v-model.trim="promotionName">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="status">Estado</label>
              <VueNextSelect
                class="form-control generalInput"
                id="status"
                :options="statusDescriptions"
                v-model.trim="status"
                placeholder=""
                searchable="true"
                clear-on-close="true"
                close-on-select
              >
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-12">
            <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
              <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
              <button class="btn btn-primary generalPrimaryButton" :disabled="isLoading" @click="filter">
                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Buscar</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import VueNextSelect from 'vue-next-select'
export default {
  name: 'PromotionsFilters',
  components: {
    VueNextSelect
  },
  props: {
    filterURL: String,
    isLoading: Boolean,
  },
  data() {
    return {
      promotionId: '',
      status: '',
      promotionName: '',
      statusDescriptions: ['ACTIVO', 'PENDIENTE', 'DESACTIVADO', 'ELIMINADO'],
      statusDescriptionsEsp:['ACTIVATED', 'PENDING', 'DEACTIVATED', 'DELETED'],
    };
  },
  computed: {
    filtersApplied() {
      return {
        name: encodeURIComponent(this.promotionName),
        promotionId: this.promotionId,
        status: this.statusDescriptionsEsp[this.statusDescriptions.indexOf(this.status)]
      };
    },
  },
  mounted() {
    if(this.filterURL && this.filterURL !== '') {
      let indexStatus = this.statusDescriptionsEsp.indexOf(decodeURIComponent(this.filterURL));
      let filterURLEsp = this.statusDescriptions[indexStatus];
      this.$nextTick(() => {
        this.status =filterURLEsp;
      })
      this.$nextTick(() => {
        this.filter();
      })
    }
  },
  methods: {
    filter() {
      const statusIndex = this.statusDescriptions.indexOf(this.status);
      const statusValue = statusIndex !== -1 ? this.statusDescriptionsEsp[statusIndex] : ''; // Convertir al valor en inglés

      this.$emit('filter', {
        name: this.promotionName || '',
        promotionId: this.promotionId || '',
        status: statusValue
      });
    },
    cleanSearch() {
      this.promotionName = '';
      this.promotionId = '';
      this.status = '';
      //this.filtersApplied.status = '';
      this.filter();
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}
.link-primary {
  color:$primary;
  cursor:pointer;

  &:hover {
    color: $primary-hover;
  }
}
</style>
